import angular from "angular";
import uiBootstrap from "angular-ui-bootstrap";
import {
  MachineConfigurationTypeSubmitOptionsModalService,
  vsServiceName,
} from "./service";
import {
  vsComponentName,
  machineConfigurationTypeSubmitOptionsModalServiceComponentOptions,
} from "./component";

export const vsModuleName =
  "machineConfigurationTypeSubmitOptionsModalServiceModule";

angular
  .module(vsModuleName, [uiBootstrap])
  .service(vsServiceName, MachineConfigurationTypeSubmitOptionsModalService)
  .component(
    vsComponentName,
    machineConfigurationTypeSubmitOptionsModalServiceComponentOptions
  );
